var map = {
	"./1.jpg": 7414,
	"./2.jpg": 95777,
	"./3.jpg": 79627,
	"./4.jpg": 10181,
	"./5.jpg": 1886,
	"./6.jpg": 53995,
	"components/Project/img/peregorodka/1.jpg": 7414,
	"components/Project/img/peregorodka/2.jpg": 95777,
	"components/Project/img/peregorodka/3.jpg": 79627,
	"components/Project/img/peregorodka/4.jpg": 10181,
	"components/Project/img/peregorodka/5.jpg": 1886,
	"components/Project/img/peregorodka/6.jpg": 53995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23745;